import { Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'features';
import { clearDownloadList, selectDownloadList, selectIsGeneratingFile } from 'features/Downloads';
import { IconType } from 'react-icons';
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdOutlineClose } from 'react-icons/md';
import IntlMessages from 'util/IntlMessages';

type DownloaderHeaderProps = {
  isOpen: boolean;
  toggleOpen: () => void;
};

const DownloaderHeader: React.FC<DownloaderHeaderProps> = (props) => {
  const { isOpen, toggleOpen } = props;
  const dispatch = useAppDispatch();

  const downloadList = useAppSelector(selectDownloadList);
  const isGeneratingFile = useAppSelector(selectIsGeneratingFile);

  const areFilesDownloading = downloadList?.some((file) => file.status === 'downloading');
  const downloadedFilesCount = downloadList?.filter((file) => file.status === 'downloaded').length;
  const downloadingFilesCount = downloadList?.filter(
    (file) => file.status === 'downloading'
  ).length;

  const ArrowIcon: IconType = isOpen ? MdKeyboardArrowDown : MdKeyboardArrowUp;

  const handleClearList = () => dispatch(clearDownloadList());

  return (
    <div className="downloader-header">
      <Typography fontWeight={700}>
        {isGeneratingFile ? (
          <IntlMessages id="pages.downloader.header.preparing" />
        ) : areFilesDownloading ? (
          <IntlMessages
            id="pages.downloader.header.downloading"
            values={{ downloadingFilesCount }}
          />
        ) : (
          <IntlMessages id="pages.downloader.header.downloads" values={{ downloadedFilesCount }} />
        )}
      </Typography>

      <div className="downloader-header-icons">
        <ArrowIcon onClick={toggleOpen} size={24} />
        <MdOutlineClose onClick={handleClearList} size={20} />
      </div>
    </div>
  );
};

export default DownloaderHeader;
